var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    {
      scopedSlots: _vm._u([
        {
          key: "aside-control",
          fn: function () {
            return [
              _c("ToolLayers", {
                attrs: {
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                },
              }),
              _vm._v(" "),
              _c("ToolPrintvisible", {
                attrs: {
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                },
              }),
              _vm._v(" "),
              _c("ToolRegulations", {
                attrs: {
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                },
              }),
              _vm._v(" "),
              _c("PanelMapWrapper", {
                attrs: { moduleCode: _vm.moduleCode, mapId: _vm.mapId },
              }),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.enableSearch
                    ? _c("SearchControl", {
                        attrs: {
                          "data-panel": "search",
                          moduleCode: _vm.moduleCode,
                          mapId: _vm.mapId,
                          posBtnMap: _vm.mapButtons.search.position,
                          idxBtnMap: _vm.mapButtons.search.order,
                          showLabelBtnMap: _vm.mapButtons.search.showLabel,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("MapComponent", {
        ref: "MapComponent",
        attrs: {
          id: _vm.mapId,
          url: _vm.url,
          acl: _vm.acl,
          mapTools: _vm.mapTools,
          moduleCode: _vm.moduleCode,
          showLoadingSpin: false,
          activeExpandCollapse: _vm.activeExpandCollapse,
          initialCollapsedExpandCollapse: _vm.initialCollapsedExpandCollapse,
          enableLayerSwitcher: _vm.enableLayerSwitcher,
          enableStreetView: _vm.enableStreetView,
          enableBackoffice: _vm.enableBackoffice,
          enableIdentify: _vm.enableIdentify,
          enableScaleLine: _vm.enableScaleLine,
          enableScaleBox: _vm.enableScaleBox,
          enableMousePosition: _vm.enableMousePosition,
          enableMeasure: _vm.enableMeasure,
          enableCatalog: _vm.enableCatalog,
          enableAnnotations: _vm.enableAnnotations,
          enableAttribution: _vm.enableAttribution,
        },
      }),
      _vm._v(" "),
      _vm._v(" "),
      _c("PanelCemetery", {
        key: "cemetery",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("PanelSector", {
        key: "sector",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("PanelOccupation", {
        key: "occupation",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("PanelInterment", {
        key: "interment",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("PanelDeedOwner", {
        key: "deedowner",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("PanelDeedOwnerHolder", {
        key: "deedownerholder",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("PanelEntity", {
        key: "entity",
        attrs: { moduleCode: _vm.moduleCode },
      }),
      _vm._v(" "),
      _c("AdvancedSearch", {
        key: "advanced-search",
        attrs: { moduleCode: _vm.moduleCode },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }